import { render, staticRenderFns } from "./StartWaiting.vue?vue&type=template&id=76647446&scoped=true"
import script from "./StartWaiting.vue?vue&type=script&lang=js"
export * from "./StartWaiting.vue?vue&type=script&lang=js"
import style0 from "./StartWaiting.vue?vue&type=style&index=0&id=76647446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76647446",
  null
  
)

export default component.exports